import _extends from '@babel/runtime/helpers/extends';
import _slicedToArray from '@babel/runtime/helpers/slicedToArray';
import _objectWithoutProperties from '@babel/runtime/helpers/objectWithoutProperties';
import classnames from 'classnames';
import React, { useState, useEffect } from 'react';
import alertUserOfDeprecatedProps from '../../utils/deprecation.js';

var _excluded = ["className", "data-testid", "disabled", "error", "id", "options", "onChange", "onUpdate", "optionsProps", "required", "value"];
var InputRadio = function InputRadio(_ref) {
  var className = _ref.className,
    dataTestId = _ref['data-testid'],
    disabled = _ref.disabled,
    error = _ref.error,
    id = _ref.id,
    options = _ref.options,
    onChange = _ref.onChange,
    onUpdate = _ref.onUpdate,
    optionsProps = _ref.optionsProps,
    _ref$required = _ref.required,
    required = _ref$required === void 0 ? false : _ref$required,
    value = _ref.value,
    otherProps = _objectWithoutProperties(_ref, _excluded);
  alertUserOfDeprecatedProps('InputRadio', otherProps);
  if (!id) {
    console.error("Hey Canvas User! A unique id is required for the radio input.");
  }
  var _useState = useState(),
    _useState2 = _slicedToArray(_useState, 2),
    radioValue = _useState2[0],
    setRadioValue = _useState2[1];
  useEffect(function () {
    setRadioValue(value);
  }, [value]);
  var finalClasses = classnames('C-InputRadio', className);
  var radioClasses = classnames('C-InputRadio__Option__Selector', {
    isErrored: error
  });
  var handleOnChange = function handleOnChange(value, event) {
    setRadioValue(value);
    onChange && onChange(event);
    onUpdate && onUpdate(id, value);
  };
  return /*#__PURE__*/React.createElement("fieldset", _extends({
    "data-testid": dataTestId,
    className: finalClasses
  }, otherProps), /*#__PURE__*/React.createElement("legend", {
    className: "hc-sr-only"
  }, "Group of ".concat(options.length, " radio options. ").concat(required ? 'You must select one option.' : '')), options.map(function (option, index) {
    var optionClassName = classnames('C-InputRadio__Option', {
      isDisabled: disabled || option.disabled
    });
    return /*#__PURE__*/React.createElement("label", {
      key: "".concat(id, "_").concat(index),
      htmlFor: "".concat(id, "_").concat(index),
      className: optionClassName,
      "data-testid": dataTestId ? "".concat(dataTestId, "_").concat(option.value, "_label") : null
    }, /*#__PURE__*/React.createElement("input", _extends({
      className: "C-InputRadio__Option__Input",
      id: "".concat(id, "_").concat(index),
      name: id,
      "data-testid": dataTestId ? "".concat(dataTestId, "_").concat(option.value) : null,
      value: option.value,
      type: "radio",
      required: required,
      "aria-required": required ? 'true' : 'false',
      disabled: disabled || option.disabled,
      onChange: function onChange(event) {
        return handleOnChange(option.value, event);
      },
      checked: option.value === radioValue,
      "aria-checked": option.value === radioValue
    }, optionsProps)), /*#__PURE__*/React.createElement("span", {
      key: "".concat(id, "_").concat(index),
      className: radioClasses
    }), option.label);
  }));
};
InputRadio.displayName = 'Input.Radio';

export { InputRadio as default };
